import { required, maxLength, numeric, alphaNum, minLength, integer, minValue } from 'vuelidate/lib/validators'

const regexSenha = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9@!#$?&%*]+$/g.test(value)
}
const senhaForte = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /[a-z]/.test(value) && /[A-Z]/.test(value) && (/[0-9]/.test(value) || /[@!#$?%&*]/.test(value))
}
const regexUsuario = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9\s]+$/g.test(value)
}

export const validateData = {
  form: {
    numero: { required, maxLength: maxLength(10), numeric },
    usuario: { required, maxLength: maxLength(30), regexUsuario },
    limiteLogin: { required, integer, maxLength: maxLength(2), minValue: minValue(1) },
    quantidadeChamadasParaOcupado: { required, integer, maxLength: maxLength(2), minValue: minValue(1) },
    dtmf: { required, alphaNum },
    senhaRamal: { required, minLength: minLength(8), maxLength: maxLength(20), regexSenha, senhaForte },
  },
}

export const validateComputed = {
  numeroErrors() {
    const errors = []
    if (!this.$v.form.numero.$dirty) return errors
    !this.$v.form.numero.maxLength && errors.push('Número não pode ter mais de 10 dígitos')
    !this.$v.form.numero.required && errors.push('Número é obrigatório.')
    !this.$v.form.numero.numeric && errors.push('Apenas caracteres numéricos são válidos.')
    return errors
  },
  usuarioErrors() {
    const errors = []
    if (!this.$v.form.usuario.$dirty) return errors
    !this.$v.form.usuario.maxLength && errors.push('Nome não pode ter mais de 30 dígitos')
    !this.$v.form.usuario.required && errors.push('Nome é obrigatório.')
    !this.$v.form.usuario.regexUsuario && errors.push('Apenas letras, números e/ou espaço.')
    return errors
  },
  senhaRamalErrors() {
    const errors = []
    if (!this.$v.form.senhaRamal.$dirty) return errors
    !this.$v.form.senhaRamal.required && errors.push('Senha é obrigatória.')
    !this.$v.form.senhaRamal.minLength && errors.push('Senha deve ter no mínimo 8 dígitos.')
    !this.$v.form.senhaRamal.maxLength && errors.push('Senha deve ter no máximo 20 dígitos.')
    !this.$v.form.senhaRamal.regexSenha && errors.push('Caractere inválido na senha.')
    !this.$v.form.senhaRamal.senhaForte && errors.push('Senha não é forte.')
    return errors
  },
  limiteLoginErrors() {
    const errors = []
    if (!this.$v.form.limiteLogin.$dirty) return errors
    !this.$v.form.limiteLogin.required && errors.push('Aparelhos simultâneos é obrigatória.')
    !this.$v.form.limiteLogin.maxLength && errors.push('Aparelhos simultâneos não deve ter mais de 2 dígitos.')
    !this.$v.form.limiteLogin.integer && errors.push('Aparelhos simultâneos deve ser um número positivo inteiro.')
    !this.$v.form.limiteLogin.minValue && errors.push('Valor mínimo permitido é 1.')
    return errors
  },
  quantidadeChamadasParaOcupadoErrors() {
    const errors = []
    if (!this.$v.form.quantidadeChamadasParaOcupado.$dirty) return errors
    !this.$v.form.quantidadeChamadasParaOcupado.required && errors.push('Ocupado com N Ligações é obrigatória.')
    !this.$v.form.quantidadeChamadasParaOcupado.maxLength &&
      errors.push('Ocupado com N Ligações não deve ter mais de 2 dígitos.')
    !this.$v.form.quantidadeChamadasParaOcupado.integer &&
      errors.push('Ocupado com N Ligações deve ser um número positivo inteiro.')
    !this.$v.form.quantidadeChamadasParaOcupado.minValue && errors.push('Valor mínimo permitido é 1.')
    return errors
  },
  dtmfErrors() {
    const errors = []
    if (!this.$v.form.dtmf.$dirty) return errors
    !this.$v.form.dtmf.required && errors.push('DTMF é obrigatório.')
    !this.$v.form.dtmf.alphaNum && errors.push('DTMF deve ser uma das opções acima.')
    return errors
  },
}
